import { useEffect, useState } from "react";
import { Pagination } from "../../../components/Pagination";
import { getSmiNewsLinks } from "../../../api/transport/newsTransport";
import { Loader } from "../../../components/Loader";
import { SmiNewsLinkDto } from "../../../types/news";
import { getHashParam, getStaticUrl, setDocumentTitle, updateHashParams } from "../../../utils";
import { SmiLinkCard } from "./SmiLinkCard";

const NEWS_PER_PAGE = 9;

const SmiNewsPage: React.FC = () => {
    const [newsLinks, setNewsLinks] = useState<SmiNewsLinkDto[]>([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        const page = getHashParam('page');
        if (page) {
            setCurrentPage(+page);
        }
        setLoading(true);
        getSmiNewsLinks().then((data) => {
            setNewsLinks(data);
        }).finally(() => {
            setLoading(false);
        });

        setDocumentTitle(`СМИ о «РОДИНЕ» - Официальный сайт ФК «Родина»`);
    }, []);

    if (loading) {
        return <Loader />;
    }

    const perPage = NEWS_PER_PAGE;

    const totalPages = Math.ceil(newsLinks.length / perPage);
    if (currentPage > totalPages) {
        setCurrentPage(totalPages);
    }

    const links = newsLinks?.filter((l, i) => {
        return i >= (currentPage - 1) * perPage && i < currentPage * perPage;
    });

    const onPageChange = (page: number) => {
        const pageToSet = page + 1;
        setCurrentPage(pageToSet);
        updateHashParams({ page: pageToSet.toString() });
    }

    return (
        <div className="p-2 pb-8 sm:px-9 sm:py-4">
            <h1 className="py-4 sm:pb-8 text-2xl sm:text-3xl font-semibold text-center">СМИ о «РОДИНЕ»</h1>
            <div className="flex flex-row justify-center flex-wrap gap-2 sm:gap-8 items-center">
                {links.map((link) => <SmiLinkCard key={link.uuid} url={link.linkUrl} imageUrl={getStaticUrl(link.imageUrl)} title={link.name} />)}
            </div>
            <Pagination
                totalPages={Math.ceil(newsLinks.length / perPage)}
                currentPage={currentPage-1}
                onChange={onPageChange}
            />
        </div>
    );
}

export default SmiNewsPage;